function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M92.64,437.8c1-3.68-1.47-7.37-4.17-10s-5.93-5.05-7.34-8.58c-2.28-5.72.78-13.12-3.1-17.89-2.29-2.8-6.39-3.74-8.42-6.74a15.23,15.23,0,0,1-1.83-5.35,54.32,54.32,0,0,0-13.53-25.32,47.22,47.22,0,0,0,5.31,24.4c1.57,3,3.51,5.92,4,9.27.85,5.43-2.19,11-.85,16.36,1.53,6.1,8.38,10.19,8.7,16.47.28,5.31-4.35,10-4,15.28A14.22,14.22,0,0,0,69.8,452c4.1,6.83,10.14,11.53,19.28,11.38l11.2.39Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M315.4,193.71c-1,2,2.73,3.64,4.88,4.29a19.62,19.62,0,0,0,6.71.46c3-.16,6.07-.44,8.66-1.92a13.82,13.82,0,0,0,5.22-5.85,41.15,41.15,0,0,0,2.65-7.49S319.89,184.74,315.4,193.71Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M406.38,184a4.15,4.15,0,0,0-1.77-2c-2.71-1.54-5.56-1.68-8.68-1.61a31.21,31.21,0,0,0-9.15,1.79c-2.42.82-4.95,2-6.18,4.2l1.54.93a22.68,22.68,0,0,0,13.34,4.18,9.43,9.43,0,0,0,6.35-2c.77-.71,1.35-1.61,2.14-2.29.54-.46,1.17-.81,1.68-1.3A2.15,2.15,0,0,0,406.38,184Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M357.39,192.68c1.58-8.5.75-17.24-.1-25.84-2.76,7-2.66,15-5.59,21.94a9.4,9.4,0,0,0-.78,2.31,2.59,2.59,0,0,0,.66,2.26c.8.73,2,.33,3.06.21a11.94,11.94,0,0,0,2.75-.88"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M339,212.36c4,1.39,8.26-1.2,12.49-1.66,2.8-.3,5.6.34,8.38.79a62.86,62.86,0,0,0,17,.42,6.52,6.52,0,0,0,2.5-.65,3,3,0,0,0,1.31-2.48c-9.42-1-18.83-1.54-28.25-2.51a17.64,17.64,0,0,0-7.06.23c-2.84.88-5,3.11-7,5.32"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M369.44,187.71c0-.5-.08-1.09-.52-1.34a1,1,0,0,0-.9,0,2.47,2.47,0,0,0-.73.6,12.27,12.27,0,0,0-2.67,4.27l4.9-.43C369.49,189.8,369.47,188.74,369.44,187.71Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M385.71,177.4a16.07,16.07,0,0,0-3.56-7.6c2.12,6.92,1.41,10.83.22,15.57l.26-.66C384,181.94,386.08,180.2,385.71,177.4Z"
});

var SvgNoQuestionsIcon = function SvgNoQuestionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.77,463.77c0,.15-98.85.26-220.76.26s-220.78-.11-220.78-.26,98.83-.26,220.78-.26S470.77,463.63,470.77,463.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.64,437.8c1-3.68-1.47-7.37-4.17-10s-5.93-5.05-7.34-8.58c-2.28-5.72.78-13.12-3.1-17.89-2.29-2.8-6.39-3.74-8.42-6.74a15.23,15.23,0,0,1-1.83-5.35,54.32,54.32,0,0,0-13.53-25.32,47.22,47.22,0,0,0,5.31,24.4c1.57,3,3.51,5.92,4,9.27.85,5.43-2.19,11-.85,16.36,1.53,6.1,8.38,10.19,8.7,16.47.28,5.31-4.35,10-4,15.28A14.22,14.22,0,0,0,69.8,452c4.1,6.83,10.14,11.53,19.28,11.38l11.2.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _ref2), /*#__PURE__*/React.createElement("path", {
    d: "M102.54,464a9,9,0,0,0,3.09-.06,19.27,19.27,0,0,0,3.63-.92,15.55,15.55,0,0,0,4.5-2.46,6.22,6.22,0,0,0,1.85-2.47,11.67,11.67,0,0,0,.52-3.34,32.52,32.52,0,0,1,.27-3.62,9.79,9.79,0,0,1,1.36-3.6c1.32-2.32,3.52-4.52,4.22-7.67s.22-6.45-.3-9.81-1-7,.26-10.52,3.66-6.67,4.89-10.61.65-8.28.91-12.51a16.5,16.5,0,0,1,1.46-6.22c.9-2,2.16-3.85,3.14-5.93,2-4.22,2.34-9,2.88-13.69.27-2.36.53-4.75.8-7.15a35.54,35.54,0,0,1,1.25-7.17,64.16,64.16,0,0,1,2.68-6.93,24.09,24.09,0,0,0,1.3-3.61,36.45,36.45,0,0,0,.36-3.86,45.81,45.81,0,0,0-.3-7.75c-.3-2.58-.77-5.14-1.05-7.73,0-.16,0-.31,0-.45l-.06-.51-.45.22a17.3,17.3,0,0,0-6,5.09,27.65,27.65,0,0,0-3.71,6.83c-1.87,4.81-2.54,9.85-3.48,14.66s-2.14,9.54-4.6,13.54c-1.23,2-2.72,3.82-4,5.76a15.78,15.78,0,0,0-2.78,6.38c-.67,4.74,1.94,8.9,1.4,13.1a14.49,14.49,0,0,1-2,5.81c-1,1.79-2.21,3.45-3.35,5.11a32.76,32.76,0,0,0-3,5.17,16.27,16.27,0,0,0-1.38,5.61c-.27,3.78.26,7.36,0,10.74a24.75,24.75,0,0,1-2.77,9.21c-1.35,2.75-2.86,5.24-4.12,7.66-.63,1.2-1.22,2.38-1.7,3.57a17.87,17.87,0,0,0-1,3.54,22.2,22.2,0,0,0-.08,6.39,16.11,16.11,0,0,0,3.2,8.15,8.11,8.11,0,0,0,.91,1,4.55,4.55,0,0,0,.73.62c.42.31.64.45.64.45a13.93,13.93,0,0,1-2.17-2.14,16.15,16.15,0,0,1-3-8.1,22.09,22.09,0,0,1,.14-6.3,17,17,0,0,1,1-3.45,36.53,36.53,0,0,1,1.71-3.52c1.27-2.4,2.79-4.88,4.17-7.65a25,25,0,0,0,2.86-9.37c.3-3.45-.22-7.05.06-10.73a16.06,16.06,0,0,1,1.35-5.43,32.62,32.62,0,0,1,3-5.06c1.14-1.66,2.35-3.32,3.39-5.15a15,15,0,0,0,2.14-6.05c.54-4.47-2.05-8.65-1.38-13.06a15.33,15.33,0,0,1,2.69-6.1c1.27-1.91,2.77-3.73,4-5.78,2.55-4.11,3.78-8.93,4.71-13.76s1.62-9.83,3.46-14.55a26.91,26.91,0,0,1,3.61-6.64,16.59,16.59,0,0,1,5.77-4.88l-.51-.29c0,.15,0,.3.05.46.28,2.62.75,5.18,1,7.74a44.36,44.36,0,0,1,.29,7.63,37.37,37.37,0,0,1-.34,3.74,22.5,22.5,0,0,1-1.26,3.49,66.05,66.05,0,0,0-2.7,7,36.3,36.3,0,0,0-1.26,7.28c-.26,2.41-.53,4.8-.79,7.16-.54,4.71-.89,9.41-2.8,13.48-1,2-2.2,3.91-3.13,5.95a17.11,17.11,0,0,0-1.5,6.45c-.25,4.32.31,8.55-.86,12.37s-3.6,7-4.83,10.61-.78,7.43-.24,10.78,1.08,6.65.36,9.62-2.78,5.19-4.12,7.57a10.19,10.19,0,0,0-1.39,3.75,31.48,31.48,0,0,0-.24,3.66,11.2,11.2,0,0,1-.48,3.26,5.89,5.89,0,0,1-1.73,2.35,15.41,15.41,0,0,1-4.39,2.48,19.39,19.39,0,0,1-3.59,1,13.76,13.76,0,0,1-2.27.22C102.81,464,102.54,464,102.54,464Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.92,332.1a1.2,1.2,0,0,0-.11.34l-.24,1c-.22.89-.49,2.22-.91,3.88s-1.45,3.54-2.32,5.85a83.47,83.47,0,0,0-2.66,7.94c-.86,3-1.61,6.3-2.41,9.86a41.47,41.47,0,0,1-3.58,10.93c-.92,1.82-2,3.66-2.77,5.68a26.05,26.05,0,0,0-1.61,6.42,131.08,131.08,0,0,1-2.42,13.55c-2.24,9.17-4.38,17.91-6.33,25.87s-3.79,15.08-5.31,21.1-2.67,10.82-3.51,14.25c-.39,1.64-.7,2.93-.92,3.88-.09.41-.17.74-.23,1a1.85,1.85,0,0,0,0,.35,1.31,1.31,0,0,0,.13-.33c.07-.27.17-.59.29-1,.25-.93.6-2.22,1.05-3.85.9-3.4,2.17-8.23,3.74-14.18s3.4-13.15,5.45-21.06,4.13-16.71,6.39-25.89A124.72,124.72,0,0,0,122,384.1a25.83,25.83,0,0,1,1.56-6.27c.79-2,1.8-3.79,2.72-5.63,2-3.65,2.79-7.57,3.58-11.1s1.49-6.87,2.31-9.85,1.68-5.64,2.54-7.94,1.81-4.2,2.22-5.92.6-3,.78-3.92q.1-.62.18-1C137.92,332.22,137.94,332.1,137.92,332.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,464.05c7.31-4.35,9.41-17.55,6.36-25.49s-8.39-15.2-9.21-23.67c-.64-6.51,1.5-13.19,0-19.55-2.05-8.59-10.43-15.24-10.33-24.07.05-4.95,2.87-9.61,2.64-14.56-.27-6.06-4.93-10.88-7.81-16.22-4.42-8.19-4.71-17.86-6.22-27s-5-19-13.14-23.51c-1.2,7.79-3.25,13.13-2.61,23.68.24,3.79,4.64,11,5.24,19.35.36,5,.6,9.94.91,14.9s.61,9.76,2.34,14.28c1.33,3.47,3.46,6.62,4.45,10.2,1.85,6.73-.59,14,.91,20.84,1.27,5.78,5.27,10.75,6.09,16.61,1.14,8.23-4.18,16.79-1.46,24.64,1.36,3.9,4.56,7,5.47,11.05.71,3.12-.06,6.43.58,9.56,1,5.06,10.66,9,15.81,8.67",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.81,297.67a2.37,2.37,0,0,0,0,.44c0,.33.1.75.16,1.28.17,1.13.36,2.78.74,4.92s1.52,4.56,2.4,7.48,1.86,6.26,2.68,10,1.54,7.91,2.27,12.38,1.53,9.34,3.75,14c1,2.33,2.18,4.67,3,7.17a32.35,32.35,0,0,1,1.54,7.9,158.1,158.1,0,0,0,2.15,17c2.24,11.54,4.37,22.53,6.31,32.54s3.89,18.94,5.45,26.5,2.84,13.6,3.73,17.86l1,4.85c.12.52.21.93.29,1.25a2.49,2.49,0,0,0,.12.43,1.83,1.83,0,0,0,0-.44c-.06-.33-.13-.74-.22-1.27-.22-1.16-.53-2.8-.92-4.88-.84-4.27-2-10.37-3.51-17.9s-3.3-16.56-5.29-26.53-4-21-6.25-32.53a159.51,159.51,0,0,1-2.16-17,32.82,32.82,0,0,0-1.59-8.06c-.89-2.54-2.06-4.89-3.09-7.21-2.2-4.59-3-9.38-3.76-13.83s-1.49-8.63-2.36-12.39-1.82-7.12-2.8-10-2.07-5.32-2.51-7.41-.65-3.77-.86-4.88c-.1-.52-.18-.94-.24-1.27A3.39,3.39,0,0,0,68.81,297.67Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421.47,88.77h-4A3.39,3.39,0,0,1,414,92.18a3.22,3.22,0,0,1-3.12-2.06,3.56,3.56,0,0,1,.28-3.22c.68-1.12,2.16-2.13,4.84-1.66v-9h-3.93v5.26A7.68,7.68,0,0,0,406.56,89c0,5.82,5.22,7.17,7.46,7.17C415.73,96.21,421.55,95.8,421.47,88.77Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.04,
    y: 70.69,
    width: 3.99,
    height: 3.73,
    transform: "translate(828.07 145.11) rotate(180)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.28,83.45a3.26,3.26,0,0,0,0-.51c0-.36,0-.85,0-1.48,0-.32,0-.69-.05-1.09s-.11-.84-.18-1.3-.14-1-.22-1.53l-.42-1.7a27.74,27.74,0,0,0-3.6-8.25,29.09,29.09,0,0,0-21.89-13.38,29.4,29.4,0,0,0-4-.08c-.67,0-1.36,0-2,.13l-2.06.31a29.69,29.69,0,0,0-8.12,2.77,31.68,31.68,0,0,0-7.29,5.31,30.35,30.35,0,0,0-5.49,7.64A27.73,27.73,0,0,0,385,79.6a18.87,18.87,0,0,0-.21,2.49,21,21,0,0,0-.05,2.51,29.51,29.51,0,0,0,4.85,15.05l0-.31c-1.39,3.47-2.76,6.88-4.1,10.2l-.24.61.63-.18,10.9-3-.26-.06A29.18,29.18,0,0,0,409,112.37a26,26,0,0,0,6.38.39,19.47,19.47,0,0,0,3.07-.29l1.49-.23c.49-.09,1-.24,1.44-.35A29.17,29.17,0,0,0,438,100.5a27.83,27.83,0,0,0,3.57-6.77c.19-.53.37-1,.54-1.52s.26-1,.37-1.45.23-.91.33-1.33.13-.83.19-1.22c.09-.77.23-1.45.26-2s0-1.08,0-1.5,0-.68,0-.91,0-.31,0-.31a1.05,1.05,0,0,0,0,.31c0,.23,0,.53-.07.91s-.06.91-.1,1.49-.19,1.26-.31,2a29,29,0,0,1-21.51,23.2c-.47.11-.94.25-1.42.34l-1.47.22a19.93,19.93,0,0,1-3,.27,26.63,26.63,0,0,1-6.26-.41,28.85,28.85,0,0,1-12.19-5.37l-.12-.1-.15,0-10.91,3,.38.43,4.11-10.19.06-.16-.09-.15a28.76,28.76,0,0,1-4.12-9.79,29.3,29.3,0,0,1-.62-4.92,20,20,0,0,1,.05-2.45,16.37,16.37,0,0,1,.2-2.43,27.06,27.06,0,0,1,2.79-9.11,30.11,30.11,0,0,1,5.35-7.48A30.88,30.88,0,0,1,401,57.89a28.79,28.79,0,0,1,7.95-2.75l2-.31c.67-.1,1.34-.09,2-.14a29.9,29.9,0,0,1,3.91.07,28.78,28.78,0,0,1,21.63,13,27.69,27.69,0,0,1,3.66,8.12l.45,1.68c.09.53.17,1,.25,1.5s.14.9.21,1.3.05.76.08,1.08c0,.62.08,1.11.11,1.47A1.69,1.69,0,0,0,443.28,83.45Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--question-mark--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.07,201.38h57.75s0-48.49,50.39-49.35c26.17-.46,39.74,16.69,45.26,29.82,6.4,15.25,4.46,32.63-4.12,46.78-9.79,16.15-30.89,32.38-69.81,25.52l-.37,128.67h57.11V306.54s80.09-20.7,80.09-109c0-84.45-68.29-102.69-105-103.87-20.42-.65-27.82-1.53-53.08,2.06C171.1,100.33,144.39,137.71,145.07,201.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.01,
    y: 409.64,
    width: 57.96,
    height: 54.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.01,
    y: 409.64,
    width: 57.96,
    height: 54.13,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.07,201.38h57.75s0-48.49,50.39-49.35c26.17-.46,39.74,16.69,45.26,29.82,6.4,15.25,4.46,32.63-4.12,46.78-9.79,16.15-30.89,32.38-69.81,25.52l-.37,128.67h57.11V306.54s80.09-20.7,80.09-109c0-84.45-68.29-102.69-105-103.87-20.42-.65-27.82-1.53-53.08,2.06C171.1,100.33,144.39,137.71,145.07,201.38Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,201.38H178.9s0-48.49,50.39-49.35c26.17-.46,39.74,16.69,45.25,29.82,6.41,15.25,4.47,32.63-4.11,46.78-9.79,16.15-31.26,30.83-70.18,24V382.82h57.11V306.54s80.09-20.7,80.09-109c0-84.45-75.74-104.06-108.15-104.06C204.51,93.51,120.05,99.5,121.14,201.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.14,201.38H178.9s0-48.49,50.39-49.35c26.17-.46,39.74,16.69,45.25,29.82,6.41,15.25,4.47,32.63-4.11,46.78-9.79,16.15-31.26,30.83-70.18,24V382.82h57.11V306.54s80.09-20.7,80.09-109c0-84.45-75.74-104.06-108.15-104.06C204.51,93.51,120.05,99.5,121.14,201.38Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.09,
    y: 409.64,
    width: 57.96,
    height: 54.13,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.09,
    y: 409.64,
    width: 57.96,
    height: 54.13,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.81,152.29a5,5,0,0,1-.86,0c-.57,0-1.39-.19-2.46-.2a49.89,49.89,0,0,0-9.06.38,64.18,64.18,0,0,0-13.07,3.07,55.92,55.92,0,0,0-7.28,3.14,38.48,38.48,0,0,0-7.13,4.61,35.24,35.24,0,0,0-5.83,6.16,60.36,60.36,0,0,0-4.37,6.62,59.19,59.19,0,0,0-5.17,12.38,50.35,50.35,0,0,0-1.74,8.9c-.12,1.06-.15,1.9-.18,2.46a4.55,4.55,0,0,1-.08.86,4.78,4.78,0,0,1,0-.86c0-.57,0-1.41.09-2.48a46,46,0,0,1,1.59-9,57.6,57.6,0,0,1,5.1-12.52,59.89,59.89,0,0,1,4.39-6.69,35,35,0,0,1,5.9-6.25,38.76,38.76,0,0,1,7.22-4.67A56,56,0,0,1,210.2,155a62.82,62.82,0,0,1,13.19-3,46,46,0,0,1,9.11-.21,21.56,21.56,0,0,1,2.46.3A6.21,6.21,0,0,1,235.81,152.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.83,142s-.07-.07-.19-.22-.3-.41-.5-.7l-1.91-2.7c-.41-.58-.85-1.25-1.37-1.94l-1.8-2.19L315,131.72c-.75-.88-1.63-1.73-2.51-2.66s-1.78-1.92-2.8-2.87-2.11-1.92-3.23-2.92c-.56-.5-1.11-1-1.71-1.53l-1.86-1.47c-1.27-1-2.53-2-3.9-3a125.71,125.71,0,0,0-18.93-11.18l-5.27-2.38-5.23-2c-1.71-.71-3.45-1.21-5.13-1.77s-3.32-1.13-5-1.52l-4.78-1.25c-1.55-.41-3.09-.66-4.56-1s-2.89-.64-4.28-.81l-4-.58c-2.53-.43-4.85-.52-6.87-.72-1-.08-2-.19-2.83-.23l-2.38-.06-3.3-.11-.86,0-.29,0a.94.94,0,0,1,.29,0l.86,0h3.3l2.39,0c.87,0,1.82.12,2.84.19,2,.17,4.36.24,6.89.65l4,.54c1.39.16,2.81.52,4.29.79s3,.55,4.59,1l4.8,1.24c1.66.38,3.3,1,5,1.51s3.43,1,5.14,1.76l5.26,2,5.3,2.39a122.56,122.56,0,0,1,19,11.26c1.38,1,2.64,2.07,3.91,3.06L305,121.4c.6.5,1.15,1,1.71,1.54l3.22,3c1,1,1.9,2,2.79,2.91s1.74,1.8,2.49,2.69l2,2.55,1.78,2.22c.51.7.94,1.38,1.34,2,.78,1.17,1.39,2.09,1.82,2.75l.47.73A1.15,1.15,0,0,1,322.83,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.81,266a3.09,3.09,0,0,1-.43.6L315,268.23c-.57.73-1.29,1.6-2.18,2.57s-1.84,2.11-3,3.29-2.4,2.5-3.81,3.83-2.94,2.73-4.57,4.19a124.88,124.88,0,0,1-23.36,16.11c-1.94,1-3.77,2-5.54,2.77s-3.42,1.56-4.94,2.2-2.92,1.17-4.14,1.64-2.29.85-3.17,1.13l-2,.65a3.49,3.49,0,0,1-.72.2,3.57,3.57,0,0,1,.68-.3l2-.74c.87-.31,1.92-.71,3.13-1.21s2.61-1,4.11-1.71,3.16-1.38,4.89-2.25,3.58-1.79,5.51-2.8c3.81-2.1,7.92-4.56,12.07-7.4s7.88-5.83,11.2-8.65c1.63-1.44,3.19-2.79,4.58-4.15s2.69-2.59,3.84-3.77,2.16-2.27,3.06-3.23,1.64-1.8,2.24-2.5l1.4-1.59A4.54,4.54,0,0,1,316.81,266Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.35,378.28c-.15,0-.27-16.06-.27-35.87s.12-35.88.27-35.88.26,16.06.26,35.88S256.49,378.28,256.35,378.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.55,460.1c-.15,0-.26-11.27-.26-25.17s.11-25.18.26-25.18.26,11.27.26,25.18S258.69,460.1,258.55,460.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.4,193.71c-1,2,2.73,3.64,4.88,4.29a19.62,19.62,0,0,0,6.71.46c3-.16,6.07-.44,8.66-1.92a13.82,13.82,0,0,0,5.22-5.85,41.15,41.15,0,0,0,2.65-7.49S319.89,184.74,315.4,193.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _ref3), /*#__PURE__*/React.createElement("path", {
    d: "M382.14,187.31a22.68,22.68,0,0,0,13.34,4.18,9.43,9.43,0,0,0,6.35-2c.77-.71,1.35-1.61,2.14-2.29.54-.46,1.17-.81,1.68-1.3a2.15,2.15,0,0,0,.73-1.9A3.93,3.93,0,0,0,405,181.8c-2.71-1.54-5.95-1.48-9.07-1.41a31.21,31.21,0,0,0-9.15,1.79c-2.42.82-4.95,2-6.18,4.2",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _ref4), /*#__PURE__*/React.createElement("path", {
    d: "M336,223.2l49.85.66a.65.65,0,0,0,.62-.84l-5.85-18.24s.86-9.12,2.05-20.08c1.81-16.65,4.22-37.58,4.25-37.52-3.41-9.56-23.53-11.18-23.53-11.18l-22.93,1.36-.8-1.35-6.6,3.07a30.13,30.13,0,0,0-4.14,2.34c-4.36,2.91-14.86,9.6-16.78,17.05-4.43,17.25,3.07,36.5,3.07,36.5l4.82-3.77a33.84,33.84,0,0,1,3.82-2.55l9.66,25.89a4.57,4.57,0,0,0-2.1,3.32c-.08,2.1,1,4.62,4.59,5.34",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _ref5), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _ref6), /*#__PURE__*/React.createElement("path", {
    d: "M404.94,180.72c-4.07-9.17-18.42-34.53-18.42-34.53l-11.11,13.93L378,187.47s5.87-6.55,22.28-6.68a8,8,0,0,1,6.1,3.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.23,175.87a37.71,37.71,0,0,1-1.88-6,37.89,37.89,0,0,1-1.36-6.11,39.68,39.68,0,0,1,1.87,6A38.64,38.64,0,0,1,338.23,175.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.57,158.27a6.59,6.59,0,0,1,1,.87,29,29,0,0,1,2.48,2.72,26.41,26.41,0,0,1,5.31,10.86,20.49,20.49,0,0,1,.31,6.7c-.25,2.05-.64,3.85-.9,5.37s-.42,2.76-.5,3.62a6.7,6.7,0,0,1-.14,1.33,6,6,0,0,1-.06-1.35,32.42,32.42,0,0,1,.34-3.66c.21-1.53.56-3.35.79-5.36a20.69,20.69,0,0,0-.35-6.54,27.57,27.57,0,0,0-5.09-10.74C375.93,159.63,374.49,158.35,374.57,158.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.39,221a4.26,4.26,0,0,1-1.09.32,9.73,9.73,0,0,1-1.3.25c-.51.07-1.09.18-1.74.21a25.07,25.07,0,0,1-4.58,0,29.57,29.57,0,0,1-5.5-1.1,30,30,0,0,1-5.16-2.21,26.39,26.39,0,0,1-3.79-2.57c-.52-.4-.94-.82-1.32-1.17a11.52,11.52,0,0,1-.93-.94,3.91,3.91,0,0,1-.71-.88c.07-.07,1.14,1.13,3.19,2.7a28.77,28.77,0,0,0,3.79,2.44,31.79,31.79,0,0,0,5.08,2.13,31.34,31.34,0,0,0,5.4,1.12,29.61,29.61,0,0,0,4.5.14C362.8,221.3,364.37,220.92,364.39,221Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,215.32a3.48,3.48,0,0,1,.39,1.46,9,9,0,0,1-.27,3.64,6.32,6.32,0,0,1-2,3.1c-.73.61-1.29.8-1.32.75s.44-.38,1.07-1a7.08,7.08,0,0,0,1.71-3C380.16,217.63,379.59,215.33,379.78,215.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.07,218.84a5.42,5.42,0,0,1-2.14,5.52c-.11-.11.82-1.1,1.4-2.63S376.92,218.85,377.07,218.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,185.94a21.23,21.23,0,0,1-1.78,2.56,20.49,20.49,0,0,1-1.75,2.58,6.41,6.41,0,0,1,1.32-2.88A6.31,6.31,0,0,1,368.15,185.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.93,161.72a25.09,25.09,0,0,1-2.21-1.46,28.39,28.39,0,0,0-11.81-4.41,22.28,22.28,0,0,1-2.63-.35,9.76,9.76,0,0,1,2.67,0,23.88,23.88,0,0,1,12,4.47A9.54,9.54,0,0,1,333.93,161.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.52,145.86a43.23,43.23,0,0,0-5,4.73,43,43,0,0,0-3.79,5.78,6.1,6.1,0,0,1,.69-1.94,20.17,20.17,0,0,1,2.7-4.18,19.64,19.64,0,0,1,3.66-3.37A5.88,5.88,0,0,1,386.52,145.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.94,137.62a2.19,2.19,0,0,1,.22.46,8.92,8.92,0,0,1,.47,1.4,11.77,11.77,0,0,1,0,5.42,13.34,13.34,0,0,1-4.08,6.89,13.85,13.85,0,0,1-9.2,3.28A15.61,15.61,0,0,1,344,152a17.71,17.71,0,0,1-5.11-6.19,18.75,18.75,0,0,1-1.7-5.15,11.26,11.26,0,0,1-.18-1.46,1.61,1.61,0,0,1,0-.52s.11.7.39,1.94a20.39,20.39,0,0,0,1.83,5,17.72,17.72,0,0,0,5.07,6,15.28,15.28,0,0,0,9,3,13.52,13.52,0,0,0,8.89-3.12,13.2,13.2,0,0,0,4-6.62,12.2,12.2,0,0,0,.18-5.28C366.18,138.28,365.88,137.64,365.94,137.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _ref7), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _ref8), /*#__PURE__*/React.createElement("polygon", {
    points: "375.92 409.86 372.93 454.71 353.43 454.48 350.36 407.85 375.92 409.86",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.48,448.81v1.3s22,8.84,22.21,13L352,462.87l.68-14.53C359.19,451.39,366,451.77,373.48,448.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.11,453a1.78,1.78,0,0,0-1.24,2,1.7,1.7,0,0,0,2,1.25,1.87,1.87,0,0,0,1.3-2.15,1.77,1.77,0,0,0-2.22-1.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,462.87l.16-3.49L394,460.9s1.94.86,1.71,2.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.64,450.23c0,.21-1.08.3-2.13,1s-1.62,1.57-1.81,1.49.13-1.32,1.42-2.12S373.69,450,373.64,450.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,452.15c.05.21-.88.56-1.61,1.46s-.94,1.85-1.16,1.84-.34-1.22.59-2.31S378.2,452,378.21,452.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.78,457.65c-.2,0-.49-1,.07-2.19s1.55-1.62,1.64-1.45-.53.8-1,1.77S381,457.63,380.78,457.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.36,81.85c1.13-2.8-.24-6.19-2.67-8A11.64,11.64,0,0,0,361,72.16a34.61,34.61,0,0,0-8.54,3,9.63,9.63,0,0,0-16.36,5.34,6.14,6.14,0,0,0-7.27,8.05l13.52,4.75,14.76,26a11.81,11.81,0,0,0,17.38-15.7,10.25,10.25,0,0,0,2.08-2.56,10.34,10.34,0,0,0,4.77-6.4C382.65,88.85,378.17,82.53,372.36,81.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.41,136c-.84-4.23-1.42-7.13-1.41-7.1s8-3.1,7.42-14.23c-.28-5.54-2.39-14.27-4.35-21.35-1.76-6.38-7.71-13.41-14-11.38L332,91.24c-1.91.62-2.24,2.42-1.79,4.37l0,1,7.41,30.66,3.13,13.7a11.57,11.57,0,0,0,12.92,8.78h0A11.58,11.58,0,0,0,363.41,136Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,100.72a1.42,1.42,0,0,1-1,1.68,1.36,1.36,0,0,1-1.69-1,1.41,1.41,0,0,1,1-1.67A1.35,1.35,0,0,1,365,100.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.13,98.59c-.14.22-1.35-.33-2.83,0s-2.42,1.29-2.62,1.14,0-.43.41-.87a3.9,3.9,0,0,1,2.05-1.14,3.67,3.67,0,0,1,2.3.25C364,98.2,364.19,98.5,364.13,98.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.48,104a1.41,1.41,0,0,1-1,1.67,1.36,1.36,0,0,1-1.69-.94,1.42,1.42,0,0,1,1-1.68A1.36,1.36,0,0,1,350.48,104Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.75,102.12c-.13.22-1.35-.34-2.83,0s-2.42,1.28-2.62,1.14,0-.43.41-.88a3.93,3.93,0,0,1,2.05-1.13,3.75,3.75,0,0,1,2.3.24C349.59,101.73,349.82,102,349.75,102.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.28,111.52a10.53,10.53,0,0,1,2.32-.94c.37-.12.72-.27.73-.54a2,2,0,0,0-.49-1.07l-1.73-2.66c-2.42-3.79-4.26-6.93-4.11-7s2.24,2.9,4.66,6.69l1.69,2.68a2.29,2.29,0,0,1,.51,1.45,1,1,0,0,1-.51.68,2.52,2.52,0,0,1-.62.23A9.18,9.18,0,0,1,357.28,111.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,128.9a28,28,0,0,1-15.24-.82s5.24,6.84,15.81,3.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,100c-.1.43-1.63.42-3.37.85s-3.12,1.08-3.4.74c-.12-.16.08-.58.61-1a5.74,5.74,0,0,1,2.44-1.21,5.87,5.87,0,0,1,2.71,0C349.7,99.51,350.07,99.8,350,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.56,93.87c-.24.4-1.52.3-3,.59s-2.65.79-3,.5c-.16-.15,0-.53.43-1a4.78,4.78,0,0,1,2.31-1.06,4.71,4.71,0,0,1,2.51.18C363.42,93.36,363.66,93.67,363.56,93.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.71,84.08a7.53,7.53,0,0,0,10.21,5.47c1.58-.64,3.22-1.84,4.82-1.26S354,91.15,355.53,92c2.25,1.26,5-.92,7.51-.7,2,.17,3.51,1.7,5.06,3s3.69,2.28,5.44,1.34a22.1,22.1,0,0,0-1.77-4.82,7.46,7.46,0,0,0-3.66-3.46c-.88-.35-1.83-.47-2.67-.9-1.81-.92-2.62-3-3.93-4.57a8.25,8.25,0,0,0-7-2.8c-2.16.22-4.21,1.31-6.39,1.22-1.61-.07-3.15-.79-4.76-.76-3.13,0-5.48,2.8-7.22,5.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,86.37c-1.44-.11-4.38-.41-5.35-1.43a8.44,8.44,0,0,0-8-2.64,7,7,0,0,0-5,6.66,10,10,0,0,0-7.3,7.17,11.62,11.62,0,0,0,2.5,10.51,20.82,20.82,0,0,1,1.64,2.37,16.94,16.94,0,0,0-1.78,2.7c-2.29,5.06,3.92,7,3.92,7,0,3.4,3.15,3.38,5.16,3.37s3.12,5.36,4.69,5.15l-1.59-16.57a2.06,2.06,0,0,0,.73.14c3.79.07,2.8-7.11,1.58-9a22.2,22.2,0,0,0,2.84-4.58,15.51,15.51,0,0,0,.14-7.66C342.7,89.4,347.87,86.41,347.25,86.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.64,111.54a3.21,3.21,0,0,0-5.15-1.72c-1,.86-1.53,2.3-.93,4.71,1.62,6.44,7.75,3.49,7.71,3.31S337.34,114.2,336.64,111.54Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.69,115.89s-.09.11-.26.24a1.15,1.15,0,0,1-.83.23c-.74-.08-1.59-1-1.91-2.17a3.88,3.88,0,0,1-.09-1.68,1.35,1.35,0,0,1,.63-1.08.59.59,0,0,1,.74.15c.13.15.12.29.16.3s.11-.15,0-.4a.77.77,0,0,0-.35-.34.88.88,0,0,0-.66,0,1.65,1.65,0,0,0-.93,1.29,4,4,0,0,0,.07,1.9,3,3,0,0,0,2.33,2.37,1.26,1.26,0,0,0,1-.43C335.72,116.05,335.72,115.9,335.69,115.89Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.17,102.55s.59-.45,1.41-1.45a9.57,9.57,0,0,0,2-5,9.22,9.22,0,0,0-.36-3.7,7.94,7.94,0,0,0-2.29-3.56A9.42,9.42,0,0,0,362.75,87c-.3.1-.58.25-.86.37s-.53.3-.79.45l-.4.22v-.44a3.22,3.22,0,0,0-.81-2.1A5.15,5.15,0,0,0,358,84.22a6.83,6.83,0,0,0-4.29-.32c-2.76.63-5.1,1.89-7.31,2.15a7.06,7.06,0,0,1-5-1,3.89,3.89,0,0,1-1-1c-.16-.27-.24-.42-.22-.43a5.46,5.46,0,0,0,1.31,1.27,7,7,0,0,0,4.83.81,17,17,0,0,0,3.36-1,31.34,31.34,0,0,1,3.9-1.27,8.38,8.38,0,0,1,2.26-.23,6.87,6.87,0,0,1,2.33.54,5.64,5.64,0,0,1,2,1.44,3.81,3.81,0,0,1,.94,2.44l-.4-.22.83-.48c.31-.12.6-.28.92-.39a9.83,9.83,0,0,1,9.69,1.93,8.28,8.28,0,0,1,2.38,3.78,9.73,9.73,0,0,1-1.91,9,6.35,6.35,0,0,1-1.11,1A1.9,1.9,0,0,1,371.17,102.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.87,79.94a7.83,7.83,0,0,0-2.08-.71,5.44,5.44,0,0,0-2.46.23,4.8,4.8,0,0,0-2.53,1.84l-.25.35-.15-.4a7.51,7.51,0,0,0-6.1-4.53,9.7,9.7,0,0,0-5.86,1.7,25.89,25.89,0,0,1-4.65,2.4,7.37,7.37,0,0,1-3.52.42,5.37,5.37,0,0,1-.93-.26c-.2-.09-.31-.14-.3-.16s.45.13,1.26.21a7.68,7.68,0,0,0,3.37-.55A28.83,28.83,0,0,0,350.2,78a15.51,15.51,0,0,1,2.8-1.37,7.68,7.68,0,0,1,3.36-.43,7.89,7.89,0,0,1,6.46,4.89l-.39,0a5.22,5.22,0,0,1,2.79-1.94,5.69,5.69,0,0,1,2.62-.13,4.68,4.68,0,0,1,1.56.6A2,2,0,0,1,369.87,79.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.7,114.48A2.16,2.16,0,0,0,355,114a2.57,2.57,0,0,0-1.69,1.23.08.08,0,0,0,0,0s-.05.05-.06.08l0,0a1.28,1.28,0,0,0-.18.76,1.79,1.79,0,0,0,1,1.35,2.3,2.3,0,0,0,2.62-.38A1.87,1.87,0,0,0,356.7,114.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.2,117.59c-.08,0-.17-.3-.44-.71a3.12,3.12,0,0,0-3.25-1.48c-.49.07-.79.21-.82.14s.2-.31.74-.5a3,3,0,0,1,2.15.12,2.92,2.92,0,0,1,1.51,1.55C357.3,117.23,357.27,117.58,357.2,117.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.79,118.83s.29.5-.09,1.26a2,2,0,0,1-1.06,1,2,2,0,0,1-1.77-.21,2,2,0,0,1-.95-1.5,2.1,2.1,0,0,1,.41-1.38c.52-.66,1.1-.68,1.1-.62s-.44.23-.79.83a1.76,1.76,0,0,0-.24,1.12,1.6,1.6,0,0,0,.75,1.11,1.65,1.65,0,0,0,1.33.2,1.87,1.87,0,0,0,.91-.7C336.78,119.32,336.71,118.83,336.79,118.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.42,118.44c.05,0,0,.34-.47.56a1.31,1.31,0,0,1-1.75-1.61,1.27,1.27,0,0,1,.53-.65c.41-.25.72-.15.71-.09s-.24.13-.49.38a1,1,0,0,0,.88,1.62C333.17,118.58,333.35,118.4,333.42,118.44Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,207.25s24.76,1.44,39.4,1.57c11.33.11,16.39-2.9,18.65-10.19,1.9-6.11-2.18-17.84-2.18-17.84-7.67,0-12.4,1.1-17.33,3.41l1.31,5.36L344.34,193Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.58,195.28a19.92,19.92,0,0,0-3.73-3.71,19.6,19.6,0,0,0-4.82-2.12,3.49,3.49,0,0,1,1.59.14,10.58,10.58,0,0,1,3.52,1.55,10.45,10.45,0,0,1,2.73,2.72C392.43,194.68,392.64,195.25,392.58,195.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.35,184.16h0s-7.66,1.84-13.29,5.6l6,16.26c2,5.34,8.11,8,13,5.2,7.53-4.31,10.19-16.87,10.19-16.87l8.27-35.88-13.71-8.59-10.41,34.28",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,149.88l.56-11.8-3.07-12c-.17-.66-.25-1.49.29-1.89a1.46,1.46,0,0,1,1.85.06c.83.86,4.83,11.35,4.83,11.35s6.07-3.64,7.15-3.82,2.43,3.09,2.52,3.34a20.32,20.32,0,0,1,0,2.2s3.75.11,4.09.62a13.23,13.23,0,0,1,.43,3.19s1.59.51,1.84,1.71.77,3.18,0,3.62-2.33,1.3-2.33,1.3-.63,6.12-.8,6.68-3.68,4-3.68,4Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,211.46s.37.22,1.15.47a7.94,7.94,0,0,0,3.53.28,9.85,9.85,0,0,0,5.12-2.36,23.55,23.55,0,0,0,4.76-6,26.05,26.05,0,0,0,1.85-4.13,43.83,43.83,0,0,0,1.29-4.79c.78-3.37,1.63-7,2.53-10.86,1.8-7.71,3.82-16.33,6-25.62l0-.07.05,0c.69-.68,1.38-1.37,2.07-2.09.34-.36.68-.72,1-1.09.16-.19.33-.38.46-.57a1.44,1.44,0,0,0,.17-.61c.27-2,.48-4.07.7-6.16v-.13l.12-.06,1.91-1.07c.14-.09.36-.19.45-.27a.57.57,0,0,0,.18-.33,3.6,3.6,0,0,0,0-1,15.17,15.17,0,0,0-.45-2.17,2.7,2.7,0,0,0-1.59-1.29l-.17-.06v-.17c0-.58-.06-1.18-.13-1.77a8.1,8.1,0,0,0-.13-.88,1.46,1.46,0,0,0-.12-.37c0-.07,0,0-.06-.06a1,1,0,0,0-.17-.07,17.91,17.91,0,0,0-3.66-.41h-.26v-.26c0-.62,0-1.31,0-2a2.1,2.1,0,0,0-.24-.67c-.1-.24-.22-.47-.34-.71a8.85,8.85,0,0,0-.82-1.32,2.19,2.19,0,0,0-.51-.5.48.48,0,0,0-.53-.06,11.74,11.74,0,0,0-1.41.65c-1.86,1-3.68,2-5.46,3.08l-.26.16-.11-.28c-.94-2.37-1.88-4.71-2.8-7-.46-1.15-.91-2.3-1.37-3.43a1.4,1.4,0,0,0-1.1-1,1.11,1.11,0,0,0-1.3.48,1.16,1.16,0,0,0-.15.71c0,.22.14.56.2.83.16.58.31,1.15.46,1.72.3,1.15.59,2.28.89,3.4q.88,3.38,1.73,6.6v.07q-.3,6.16-.57,11.8V150l-9.11,29.64-2.57,8.25c-.3.93-.53,1.66-.69,2.17s-.26.73-.26.73.05-.26.19-.75l.63-2.19c.58-1.93,1.41-4.72,2.46-8.28,2.16-7.16,5.23-17.38,8.94-29.7v.05q.26-5.62.53-11.8v.07c-.57-2.15-1.16-4.35-1.75-6.59l-.9-3.4c-.15-.57-.3-1.15-.46-1.72a8.81,8.81,0,0,1-.21-.91,1.66,1.66,0,0,1,.21-1,1.6,1.6,0,0,1,.81-.68,2.06,2.06,0,0,1,1.95.44,2,2,0,0,1,.54.86l1.37,3.43c.93,2.3,1.86,4.64,2.81,7l-.37-.13c1.79-1.06,3.59-2.12,5.49-3.11a14.39,14.39,0,0,1,1.48-.67,1,1,0,0,1,.5-.07,1.2,1.2,0,0,1,.48.18,2.86,2.86,0,0,1,.63.62,8.56,8.56,0,0,1,.87,1.4c.13.25.25.49.36.74a2.57,2.57,0,0,1,.28.85c0,.71,0,1.37,0,2l-.25-.27a17.84,17.84,0,0,1,3.82.44,1.74,1.74,0,0,1,.25.11.65.65,0,0,1,.26.26,2.17,2.17,0,0,1,.17.51c.06.32.1.62.14.93.06.61.1,1.21.13,1.81l-.18-.24a3.14,3.14,0,0,1,1.91,1.58,15.45,15.45,0,0,1,.48,2.32,3.54,3.54,0,0,1,0,1.21,1.05,1.05,0,0,1-.36.62,5.09,5.09,0,0,1-.51.3L364.08,148l.13-.19c-.23,2.09-.44,4.14-.72,6.17l-.06.39a.88.88,0,0,1-.19.43,5.15,5.15,0,0,1-.49.62c-.34.38-.68.75-1,1.11-.69.72-1.38,1.41-2.08,2.09l.07-.12c-2.2,9.28-4.24,17.9-6.07,25.61-.91,3.85-1.78,7.48-2.58,10.84a41.26,41.26,0,0,1-1.32,4.82,27.12,27.12,0,0,1-1.9,4.17A23.62,23.62,0,0,1,343,210a10,10,0,0,1-5.25,2.34,7.8,7.8,0,0,1-3.59-.36,6,6,0,0,1-.85-.39Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.9,137.35c0,.07-.34.11-.87.13a10.05,10.05,0,0,0-2,.24,3.89,3.89,0,0,0-1.7.91c-.36.34-.52.63-.6.6s0-.39.33-.85a3.32,3.32,0,0,1,1.84-1.16,5.53,5.53,0,0,1,2.14-.1C359.58,137.19,359.9,137.28,359.9,137.35Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,137.46c-.13-.05-.14-.36,0-.69s.34-.56.47-.51.15.36,0,.69S357.1,137.51,357,137.46Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,141.09a9.26,9.26,0,0,1-3,.41,2,2,0,0,0-1.66.79c-.26.41-.17.75-.25.77s-.32-.33-.07-.93a1.57,1.57,0,0,1,.71-.79,3,3,0,0,1,1.2-.36A8.23,8.23,0,0,1,364.58,141.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.92,144.69c.14,0,.22.74.18,1.65s-.19,1.63-.33,1.63-.23-.75-.19-1.66S363.77,144.68,363.92,144.69Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.07,171.62l.89-3.06a.84.84,0,0,1,1.4-.36l1.17,1.19.72-2.89a.84.84,0,0,1,1.57-.16l1.63,3.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.47,171.07a13.5,13.5,0,0,1-3.53,1.14,13.07,13.07,0,0,1-3.66.64,26.68,26.68,0,0,1,7.19-1.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,154s-.37.38-.89,1.19a10.06,10.06,0,0,0-1.35,3.77,26.74,26.74,0,0,0-.18,6c.11,2.27.29,4.75.57,7.35a128.79,128.79,0,0,0,2.11,13.22c.35,1.68.67,3,.89,4,.1.42.19.77.26,1.07s.08.38.08.38-.05-.12-.12-.36-.18-.66-.29-1.07c-.25-.93-.59-2.27-1-3.95a118.68,118.68,0,0,1-2.17-13.23c-.28-2.6-.45-5.09-.55-7.36a26.81,26.81,0,0,1,.22-6,10,10,0,0,1,1.44-3.8A5.8,5.8,0,0,1,316,154Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.05,140.38l-.23.12-.66.32c-.57.27-1.4.67-2.39,1.22a87.84,87.84,0,0,0-7.51,4.7c-2.86,2-5.39,3.82-7.24,5.14l-2.19,1.55-.61.41a1.22,1.22,0,0,1-.22.14.81.81,0,0,1,.2-.17l.58-.44,2.15-1.61c1.83-1.35,4.35-3.23,7.21-5.19a76.06,76.06,0,0,1,7.56-4.66c1-.53,1.84-.91,2.43-1.16l.67-.28C337,140.4,337,140.37,337.05,140.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.74,146.89a.73.73,0,0,1-.17-.13l-.45-.39a18.68,18.68,0,0,0-1.75-1.31,36.22,36.22,0,0,0-6.43-3.25,64.68,64.68,0,0,0-6.85-2.28c-.9-.25-1.62-.43-2.13-.55l-.57-.15a.8.8,0,0,1-.2-.07l.21,0,.58.11c.51.1,1.24.26,2.14.49a55.55,55.55,0,0,1,6.9,2.23,32.88,32.88,0,0,1,6.43,3.32A12.88,12.88,0,0,1,384.74,146.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.33,223.22a1.41,1.41,0,0,1-.39-.13,7,7,0,0,1-1-.54,4.78,4.78,0,0,1-2.18-2.94,5.75,5.75,0,0,1,.39-3.66,4.81,4.81,0,0,1,.58-1c.16-.21.27-.31.28-.3a11.33,11.33,0,0,0-.73,1.33,5.93,5.93,0,0,0-.31,3.55,4.85,4.85,0,0,0,2,2.87C336.8,223,337.35,223.18,337.33,223.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.15,212.39a5,5,0,0,1,.47,1.26,4.62,4.62,0,0,1,.28,1.31,4.11,4.11,0,0,1-.48-1.25A4,4,0,0,1,334.15,212.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.67,436.6l30.5-.15L377.62,331l-.29-107.27L336,223.2l-7.43,14a50.28,50.28,0,0,0-5.71,18.14C322.36,260.2,326,276,327.26,280l11.37,36.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.28,223.86l33.52,91.37a42.14,42.14,0,0,1-4.13,35.7l-38.92,76-21.88-27.38,32.56-68L358.73,285l4.83-61,13.52-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.55,254.47s0,.16,0,.47.05.79.09,1.38c.07,1.23.16,3,.28,5.29.23,4.63.55,11.28,1,19.49s.83,18,1.33,28.9c.24,5.44.5,11.15.76,17.07.19,3,.11,6,.14,9s0,6.16,0,9.3c0,25.13.08,47.88.11,64.37,0,8.22,0,14.88,0,19.51,0,2.29,0,4.07,0,5.31,0,.58,0,1,0,1.38s0,.47,0,.47,0-.16,0-.47l0-1.38c0-1.24,0-3-.06-5.31,0-4.63-.08-11.28-.14-19.5-.07-16.49-.16-39.24-.26-64.37q0-4.71,0-9.3c0-3.06.06-6.08-.13-9-.25-5.91-.5-11.62-.73-17.06-.46-10.88-.88-20.67-1.22-28.91s-.59-14.86-.78-19.49c-.08-2.28-.14-4.06-.18-5.3,0-.59,0-1,0-1.38S374.55,254.47,374.55,254.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.78,225.66a3.62,3.62,0,0,1,.21,1c.11.64.23,1.57.37,2.73.26,2.31.54,5.52.7,9.07s.17,6.77.12,9.1c0,1.16-.07,2.11-.12,2.76a3.38,3.38,0,0,1-.12,1,28.56,28.56,0,0,1-.13-3.76c0-2.33-.11-5.53-.27-9.08s-.38-6.74-.55-9A33.71,33.71,0,0,1,373.78,225.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.06,227.72c.05.07-.52.33-.68,1.14a1.31,1.31,0,0,0,.39,1.22,1.41,1.41,0,0,0,1.5.27,1.44,1.44,0,0,0,.78-1.31,1.31,1.31,0,0,0-.67-1.09,2.43,2.43,0,0,0-1.31-.23s.1-.13.36-.21a1.7,1.7,0,0,1,1.12.11,1.63,1.63,0,0,1,1,1.39,1.79,1.79,0,0,1-3.08,1.42,1.64,1.64,0,0,1-.41-1.65,1.69,1.69,0,0,1,.64-.93C366.9,227.71,367.05,227.69,367.06,227.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.06,225.91a3,3,0,0,1,.27,1,9.46,9.46,0,0,1,.09,2.72,11.11,11.11,0,0,1-1.15,3.87,10.25,10.25,0,0,1-7.82,5.61,10.84,10.84,0,0,1-4-.15,9.44,9.44,0,0,1-2.54-.95,3.17,3.17,0,0,1-.82-.56,18.14,18.14,0,0,0,3.44,1.15,10.51,10.51,0,0,0,12.57-9A17.4,17.4,0,0,0,351.06,225.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.3,234.67a4.2,4.2,0,0,1-1.93-.23,8.91,8.91,0,0,1-3.93-2.52,8.79,8.79,0,0,1-2.13-4.16,4,4,0,0,1,0-1.93c.09,0,.1.73.4,1.85a9.67,9.67,0,0,0,5.82,6.41C389.57,234.5,390.31,234.57,390.3,234.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.21,333.17a6.38,6.38,0,0,1-1.77,1.41,8.28,8.28,0,0,1-2.27,1,5.46,5.46,0,0,1-3.07-.08,8.94,8.94,0,0,1-4.28-3.4,8.22,8.22,0,0,1-1.17-1.92,11.62,11.62,0,0,1,1.46,1.69,9.48,9.48,0,0,0,4.14,3.13,6.4,6.4,0,0,0,5-.73A19.6,19.6,0,0,1,402.21,333.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.57,339a25.3,25.3,0,0,1-3.15-4,26,26,0,0,1-2.74-4.29,24.45,24.45,0,0,1,3.16,4A23.9,23.9,0,0,1,394.57,339Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,258c-.14.05-.49-.52-.8-1.29s-.44-1.42-.31-1.48.49.52.79,1.29S343.46,258,343.33,258Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.69,260.78c-.15,0-.26-.49-.26-1.1s.11-1.11.26-1.11.26.5.26,1.11S362.83,260.78,362.69,260.78Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.73,271.3c-.14,0-.3-.6-.35-1.37s0-1.39.16-1.4.31.6.36,1.37S354.87,271.29,354.73,271.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.19,279c-.12.09-.53-.28-1.07-.66s-1-.67-1-.81.66-.06,1.27.38S340.31,279,340.19,279Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.82,288.81c-.12-.08,0-.51.34-1s.65-.77.77-.69,0,.52-.34,1S365.94,288.89,365.82,288.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,291.58c-.14,0-.26-.83-.26-1.84s.12-1.85.26-1.85.26.83.26,1.85S350.11,291.58,350,291.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.82,302.8c-.08.11-.6-.12-1.16-.53s-1-.83-.87-.95.61.12,1.17.53S344.91,302.68,344.82,302.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,306.7c.06.13-.26.4-.72.61s-.88.26-.94.13.27-.4.73-.61S360.79,306.57,360.84,306.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,325c-.12.06-.64-.71-1.15-1.73s-.82-1.9-.69-2,.65.71,1.15,1.73S350.09,324.89,350,325Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.67,323.3c-.13-.07.1-.74.5-1.51s.85-1.33,1-1.26-.1.74-.51,1.51S367.79,323.37,367.67,323.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,338.79c-.15,0-.13-.81-.29-1.75s-.4-1.69-.26-1.76.62.64.78,1.68S360.06,338.82,359.92,338.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.62,347.64c-.1.1-.6-.28-1.11-.84s-.84-1.09-.73-1.19.6.28,1.11.84S351.73,347.54,351.62,347.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.76,351c-.1-.1.27-.64.83-1.21s1.08-.94,1.19-.84-.27.65-.82,1.21S371.87,351.1,371.76,351Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.18,364.25c-.14,0-.14-.79,0-1.71s.36-1.64.51-1.62.14.78,0,1.7S360.32,364.27,360.18,364.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.39,370.68c-.13.07-.57-.45-1-1.16s-.65-1.34-.53-1.41.56.44,1,1.15S352.51,370.6,352.39,370.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,378.79c.09.12-.42.63-1.14,1.14s-1.35.83-1.44.71.43-.63,1.14-1.14S371.08,378.68,371.16,378.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.52,389.32c-.14-.05,0-.85.13-1.85s.05-1.82.2-1.84.41.82.31,1.89S355.65,389.38,355.52,389.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.77,404.44c-.12.09-.54-.25-.95-.76s-.64-1-.53-1.09.53.25.94.76S361.88,404.35,361.77,404.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,414.58c-.12.08-.67-.51-1.23-1.33s-.91-1.54-.8-1.62.67.51,1.23,1.33S355.06,414.5,354.94,414.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.75,401.85c-.13-.05-.12-.42,0-.82s.39-.7.53-.65.12.42,0,.83S373.89,401.91,373.75,401.85Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.45,426c-.13-.07.12-.78.32-1.67s.27-1.64.42-1.65.3.8.09,1.76S365.57,426.08,365.45,426Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,271.46c-.13.06-.45-.34-.71-.9s-.37-1.06-.24-1.12.45.34.71.9S371,271.4,370.85,271.46Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,240.32c.08.12-.62.68-1.37,1.48s-1.26,1.54-1.39,1.47.21-1,1-1.82S356.9,240.19,357,240.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.33,240c-.15,0-.38-.57-.73-1.25s-.67-1.24-.56-1.34.65.34,1,1.1S369.46,239.92,369.33,240Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.83,250.11c-.13-.06,0-.72.31-1.48s.65-1.35.79-1.29,0,.71-.31,1.48S331,250.16,330.83,250.11Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.08,265.21c-.1.11-.67-.21-1.28-.72s-1-1-.94-1.12.67.21,1.28.72S332.17,265.1,332.08,265.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.34,228.33c-.13,0-.41-.32-.61-.83s-.26-1-.13-1,.41.32.61.83S357.47,228.28,357.34,228.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.53,235.71c-.14,0-.13-.63,0-1.34s.39-1.27.53-1.24.13.64,0,1.35S381.67,235.74,381.53,235.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.21,247.14c-.13-.06.05-.8.41-1.67s.75-1.52.88-1.47,0,.8-.4,1.67S387.35,247.19,387.21,247.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.16,256.36c-.13.06-.61-.63-1.07-1.54s-.72-1.72-.59-1.78.6.63,1.06,1.54S383.29,256.29,383.16,256.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.82,265.58c-.13-.05,0-.63.22-1.29s.57-1.16.71-1.11,0,.63-.22,1.29S392,265.63,391.82,265.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.08,274.61c-.12.08-.43-.19-.68-.59s-.37-.8-.24-.88.42.19.68.6S384.2,274.54,384.08,274.61Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.73,293.25c-.1.09-.73-.4-1.39-1.12s-1.11-1.37-1-1.47.73.4,1.39,1.12S385.84,293.15,385.73,293.25Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.88,282.54c-.11.09-.66-.41-1.22-1.13s-.92-1.36-.81-1.45.66.42,1.22,1.13S396,282.46,395.88,282.54Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.45,297.31c-.13-.06.1-.81.51-1.67s.84-1.52,1-1.46-.09.82-.5,1.68S401.58,297.38,401.45,297.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,309.47c-.13.07-.59-.48-1.23-1.07s-1.23-1-1.17-1.15.82.12,1.52.77S389.73,309.4,389.61,309.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.35,322c0,.14-.5.26-1.11.26s-1.1-.12-1.1-.26.49-.26,1.1-.26S390.35,321.86,390.35,322Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,318.5c-.13-.07.13-.7.32-1.48s.27-1.46.42-1.47.31.72.09,1.59S402.63,318.58,402.52,318.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.61,322.71c-.13.05-.5-.66-.82-1.57s-.47-1.69-.34-1.73.51.65.83,1.56S414.75,322.66,414.61,322.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,339.91c-.12-.07.19-.91.69-1.88s1-1.7,1.15-1.63-.18.91-.69,1.87S412.81,340,412.68,339.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.65,350c-.13.05-.54-.64-.92-1.55s-.57-1.69-.43-1.75.54.64.91,1.55S401.78,350,401.65,350Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.43,353.91c0,.14-.42.26-.93.26s-.92-.12-.92-.26.42-.26.92-.26S389.43,353.77,389.43,353.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.43,370c-.13,0-.41-.55-.62-1.31s-.25-1.42-.11-1.45.41.55.62,1.31S396.57,369.92,396.43,370Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.58,364.6c-.12-.07,0-.54.33-1.05s.66-.86.78-.79,0,.55-.33,1.06S387.71,364.68,387.58,364.6Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.4,382.31c-.14,0-.34-.67-.44-1.54s-.07-1.58.07-1.6.34.67.44,1.54S387.54,382.29,387.4,382.31Z",
    style: {
      fill: "#fafafa"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoQuestionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/No-Questions-icon.f63e0460.svg";
export { ForwardRef as ReactComponent };